import { Button } from '@xo-union/tk-component-buttons';
import React, { useContext } from 'react';
import styles from './PublishWebsiteButton.scss';
import classNames from 'classnames';
import { usePublishWeddingWebsiteMutation } from '../../../generated/graphql';
import { WeddingWebsiteQuery, WeddingWebsiteQueryDocument } from '../../../generated/graphql';
import { TrackingContext } from '../../../TrackingContext';
import { useClient } from '../../../apollo/ApolloClientsProvider';

interface PublishWebsiteButtonProps {
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  isUserEmailVerified: boolean;
  isWebsitePublished: boolean;
  trackSource: string;
  onClick?: () => void;
  setShowPublishedIndexBanner?: (show: boolean) => void;
}

const PublishWebsiteButton = ({
  isUserEmailVerified,
  isWebsitePublished,
  trackSource,
  size = 'lg',
  fullWidth = false,
  onClick,
  setShowPublishedIndexBanner,
}: PublishWebsiteButtonProps) => {
  const client = useClient();
  const [publishWeddingWebsite, { loading }] = usePublishWeddingWebsiteMutation();

  const { track } = useContext(TrackingContext);

  const onPublishWebsite = async () => {
    const { data } = await publishWeddingWebsite();

    const newWebsiteState = data?.publishWeddingWebsite.state;
    const weddingWebsiteQueryResult = client.readQuery<WeddingWebsiteQuery>({
      query: WeddingWebsiteQueryDocument,
    });

    if (!newWebsiteState || !weddingWebsiteQueryResult) {
      return false;
    }

    client.writeQuery<WeddingWebsiteQuery>({
      query: WeddingWebsiteQueryDocument,
      data: {
        ...weddingWebsiteQueryResult,
        weddingWebsite: {
          ...weddingWebsiteQueryResult?.weddingWebsite,
          state: newWebsiteState,
        },
      },
    });

    return true;
  };

  const onPublishWebsiteButtonClick = async () => {
    if (!isUserEmailVerified) track('Wedding Website Enabled', { success: false, source: trackSource });
    if (isUserEmailVerified && !isWebsitePublished) {
      const wasPublishSuccessful = await onPublishWebsite();
      setShowPublishedIndexBanner?.(true);
      track('Wedding Website Enabled', { success: wasPublishSuccessful, source: trackSource });
      if (!wasPublishSuccessful) {
        return;
      }
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <>
      <Button
        size={size}
        color="secondary"
        className={classNames({ [styles.PublishWebsiteButton__FullWidth]: fullWidth })}
        onClick={onPublishWebsiteButtonClick}
        data-testid="PublishWebsiteButton__Button"
        isLoading={loading}
        loadingText="Publishing"
      >
        <span className={styles.PublishWebsiteButton__ButtonText}>Publish website</span>
      </Button>
    </>
  );
};

export default PublishWebsiteButton;
